import React from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import _ from "lodash";
import {
  Input,
  Button,
  Select,
  Checkbox,
  Row,
  Col,
  Collapse,
  AutoComplete,
  InputNumber,
  Transfer,
  Divider,
} from "antd";
const { Panel } = Collapse;
const { Option } = Select;

class FirstStep extends React.Component {
  state = {
    mockData: [],
    targetKeys: [],
    initialValue: null,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.initialValue !== this.props.initialValue) {
      this.setState({ initialValue: this.props.initialValue });
      if (this.props.initialValue && this.props.initialValue.index_id) {
        this.setState({ targetKeys: this.props.initialValue.index_id });
      } else {
        this.setState({ targetKeys: [] });
      }
    }
  }

  handleChange = (targetKeys) => {
    this.setState({ targetKeys });
  };

  render() {
    const {
      form,
      onSubmit,
      hmgGetData,
      hmgMainGetData,
      // hmgIdOneChange,
      selectHotelsGroups,
      selectHotels,
      autoCompleteOneChange,
      autoCompleteOneSelect,

      createStatus,
      current,
      next,
      prev,
      steps,
    } = this.props;
    const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
    const hmgMainIdValue = getFieldValue("hmg_main_id");

    const hmgMainIdOnChange = (value) => {
      setFieldsValue({ hmg_id: undefined });
      this.props.firstStepHmgMainIdOnChange(value);
    };

    const hmgIdOnChange = (value) => {
      this.props.hmgIdOneChange(value);
      const result = hmgGetData.find((e) => e._id === value);
      if (result) {
        setFieldsValue({ hmg_main_id: result.hmg_id });
      }
    };

    const hmgMainOptions = hmgMainGetData.map((d) => (
      <Option key={d._id}>{d.hmg_name}</Option>
    ));

    // const hmgOptions = hmgGetData.map(d => <Option key={d._id}>{d.hmg_name}</Option>);

    const hmgOptions = hmgGetData
      .filter((item) => {
        if (hmgMainIdValue) {
          if (item.hmg_id === hmgMainIdValue) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      })
      .map((d) => <Option key={d._id}>{d.project_name}</Option>);

    const hotelsGroupsOptions = selectHotelsGroups.map((d) => {
      return { value: d.hotel_group_name };
    });

    const hotelsOptions = selectHotels.map((d) => (
      <Option key={d._id}>
        {d.hotel_code} - {d.hotel_name}
      </Option>
    ));
    return (
      <div>
        <Collapse defaultActiveKey={["2_1"]} expandIconPosition="end">
          <Panel
            header={_.startCase(_.camelCase(steps[current].title))}
            key="2_1"
          >
            <Form
              labelCol={{
                xs: { span: 6 },
                sm: { span: 6 },
                md: { span: 6 },
                lg: { span: 5 },
                xl: { span: 5 },
                xxl: { span: 5 },
              }}
              wrapperCol={{
                xs: { span: 18 },
                sm: { span: 18 },
                md: { span: 18 },
                lg: { span: 15 },
                xl: { span: 12 },
                xxl: { span: 12 },
              }}
              onSubmit={onSubmit}
            >
              <Form.Item label="Id" style={{ display: "none" }}>
                {getFieldDecorator("_id")(<Input />)}
              </Form.Item>

              <div
                style={
                  current === 0 ? { display: "block" } : { display: "none" }
                }
              >
                <Form.Item label="HMG">
                  {getFieldDecorator("hmg_main_id", {
                    rules: [{ required: true, message: "Please Enter HMG" }],
                  })(
                    <Select
                      showSearch
                      optionFilterProp="children"
                      onChange={hmgMainIdOnChange}
                      placeholder="Enter HMG"
                      allowClear={true}
                    >
                      {hmgMainOptions}
                    </Select>
                  )}
                </Form.Item>

                <Form.Item label="Project Name">
                  {getFieldDecorator("hmg_id", {
                    rules: [
                      { required: true, message: "Please Enter Project Name" },
                    ],
                  })(
                    <Select
                      showSearch
                      optionFilterProp="children"
                      onChange={hmgIdOnChange}
                      placeholder="Enter Project Name"
                    >
                      {hmgOptions}
                    </Select>
                  )}
                </Form.Item>

                <Form.Item label="Hotel Group Name">
                  {getFieldDecorator("hotel_group_name_1", {
                    rules: [
                      {
                        required: true,
                        message: "Please Enter Hotel Group Name",
                      },
                    ],
                  })(
                    <AutoComplete
                      options={hotelsGroupsOptions}
                      placeholder="Enter Hotel Group Name"
                      filterOption={(inputValue, option) =>
                        option.value
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                      onChange={autoCompleteOneChange}
                      onSelect={autoCompleteOneSelect}
                      allowClear={true}
                    />
                  )}
                </Form.Item>

                <div
                  className="is_animation_1"
                  style={
                    createStatus ? { maxHeight: "0" } : { maxHeight: "100px" }
                  }
                >
                  <Form.Item label="Rename Hotels Group Name">
                    {getFieldDecorator("hotel_group_name", {
                      rules: [
                        {
                          required: true,
                          message: "Please Enter Rename Hotels Group Name",
                        },
                      ],
                    })(<Input placeholder="Enter Rename Hotels Group Name" />)}
                  </Form.Item>
                </div>

                <Form.Item label="Hotels">
                  {getFieldDecorator("hotels", {
                    rules: [
                      {
                        required: true,
                        message: "Please Enter Hotels",
                      },
                    ],
                  })(
                    <Select
                      mode="multiple"
                      optionFilterProp="children"
                      notFoundContent={null}
                      placeholder="Enter Hotels"
                    >
                      {hotelsOptions}
                    </Select>
                  )}
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
                  {/* <Button onClick={prev} style={{ marginRight: 8 }}>
                    Previous
                  </Button> */}

                  <Button type="primary" htmlType="submit">
                    {createStatus ? "Create" : "Update"}
                  </Button>
                  {/* <Button type="primary" onClick={next}>
                    Next
                  </Button> */}
                </Form.Item>
              </div>
            </Form>
          </Panel>
        </Collapse>
      </div>
    );
  }
}
const WrappedApp = Form.create({ name: "first_step_form" })(FirstStep);
export default WrappedApp;
